/**
 * Count plus noun, in en-GB: plural(1, 'item') → "1 item", plural(3, 'match', 'matches') →
 * "3 matches". Pass `pluralWord` when adding "s" isn't right.
 */
export function plural(count, word, pluralWord = `${word}s`) {
  return `${Number(count).toLocaleString('en-GB')} ${count === 1 ? word : pluralWord}`;
}
